import {UI} from "../../../stem-core/src/ui/UIBase";
import {styleRule, StyleSheet} from "../../../stem-core/src/ui/Style";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {BackArrowIcon, ForwardArrowIcon} from "../../SVGElements";
import {Messages} from "../../Messages";
import {Device} from "../../../stem-core/src/base/Device";
import {MessageElement} from "../../widget/ui/MessageElement";


class CarouselDotsStyle extends StyleSheet {
    @styleRule
    element = {
        marginBottom: 24,
        display: "flex",
        justifyContent: "center",
        width: "100%",
        position: "relative",
    };

    arrowCommon = {
        position: "absolute",
        cursor: "pointer",
    };

    @styleRule
    back = {
        left: 0,
        ...this.arrowCommon,
    };

    @styleRule
    forward = {
        right: 0,
        ...this.arrowCommon,
    };

    @styleRule
    disabledArrow = {
        opacity: 0.3,
        cursor: "not-allowed",
        pointerEvents: () => (Device.isMobileDevice() ? "none" : ""),
    }
}

@registerStyle(CarouselDotsStyle)
export class StepDescription extends UI.Element {
    static stepCount = null;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            currentStep: 0,
            stepCount: 1,
            stepDescription: "",
            forwardFunction: null,
            backFunction: null,
        }
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.element);
    }

    render() {
        const {styleSheet} = this;
        const {currentStep, backFunction, stepDescription, forwardFunction} = this.options;
        const {stepCount} = this.constructor;

        return [
            (currentStep > 1) && <BackArrowIcon className={styleSheet.back + (backFunction ? "" : styleSheet.disabledArrow)}
                                             onClick={backFunction}/>,
            <MessageElement className={styleSheet.stepDescription}
                            message={Messages.stepDescription(currentStep, stepCount, stepDescription)} />,
            (currentStep < stepCount) && <ForwardArrowIcon className={styleSheet.forward + (forwardFunction ? "" : styleSheet.disabledArrow)} onClick={forwardFunction}/>,
        ];
    }
}

